// Frequency and category options (should match backend)
export const FREQUENCY_OPTIONS = [
  { value: "monthly", label: "Miesięcznie" },
  { value: "quarterly", label: "Kwartalnie" },
  { value: "annual", label: "Rocznie" },
  { value: "one_time", label: "Jednorazowo" },
];

export const CATEGORY_OPTIONS = [
  { value: "rent", label: "Czynsz" },
  { value: "utilities", label: "Media" },
  { value: "insurance", label: "Ubezpieczenie" },
  { value: "software", label: "Oprogramowanie" },
  { value: "marketing", label: "Marketing" },
  { value: "administrative", label: "Administracyjne" },
  { value: "other", label: "Inne" },
];

export const CATEGORY_COLORS = {
  rent: "primary",
  utilities: "secondary",
  insurance: "success",
  software: "info",
  marketing: "warning",
  administrative: "default",
  other: "default",
};
